<script>
export default {
  name: 'CartFooter',
  props: {
    vendor: {
      type: Object,
      required: true,
    },
    event: {
      type: Object,
      default: null,
    },
    settings: {
      type: Object, // comm settings
      default: () => ({}),
    },
  },

  emits: ['view-policy'],

  computed: {
    vendorName() {
      return this.vendor?.account?.name
    },
    vendorTerms() {
      return this.settings?.termsOfService || ''
    },
    vendorPrivacy() {
      return this.settings?.privacyPolicy || ''
    },
  },

  methods: {
    isUrl(str) {
      return str && (str.startsWith('http://') || str.startsWith('https://'))
    },

    viewPolicy(title, content) {
      this.$emit('view-policy', { title, content })
    },
  },
}
</script>

<template>
  <footer class="footer has-text-white">
    <div class="container is-max-widescreen">
      <div class="columns">
        <!-- Vendor Column -->
        <div class="column is-6">
          <h4 class="title is-5 has-text-white mb-4">{{ vendorName }}</h4>
          <ul class="footer-links">
            <li v-if="vendorTerms && isUrl(vendorTerms)">
              <a :href="vendorTerms" target="_blank" rel="noopener" class="has-text-grey-light">Terms of Service</a>
            </li>
            <li v-else-if="vendorTerms">
              <a href="#" class="has-text-grey-light" @click.prevent="viewPolicy('Terms of Service', vendorTerms)">Terms of Service</a>
            </li>
            <li v-if="vendorPrivacy && isUrl(vendorPrivacy)">
              <a :href="vendorPrivacy" target="_blank" rel="noopener" class="has-text-grey-light">Privacy Policy</a>
            </li>
            <li v-else-if="vendorPrivacy">
              <a href="#" class="has-text-grey-light" @click.prevent="viewPolicy('Privacy Policy', vendorPrivacy)">Privacy Policy</a>
            </li>
          </ul>
        </div>

        <!-- Platform Column -->
        <div class="column is-6">
          <h4 class="title is-5 has-text-white mb-4">Liff Happens</h4>
          <ul class="footer-links">
            <li>
              <a href="https://liffhappens.com/terms" target="_blank" class="has-text-grey-light"
                >Terms of Service</a
              >
            </li>
            <li>
              <a href="https://liffhappens.com/privacy" target="_blank" class="has-text-grey-light"
                >Privacy Policy</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="content has-text-centered is-size-7 has-text-grey mt-6">
        <p>
          © {{ new Date().getFullYear() }} {{ vendorName }} &amp; Liff Happens. All rights
          reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  padding: 3rem 1.5rem;
  margin-top: auto;
  background: linear-gradient(180deg, #101828 0%, #000 100%);
}

.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  transition: color 0.2s;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.footer-links a:hover {
  color: white !important;
}

.footer-links a::before {
  content: '→';
  margin-right: 0.5rem;
  font-size: 0.9em;
  opacity: 0.7;
}
</style>
